import { UtmList } from "@/shared";
import { getUriQuery } from "@/utils/url";
import { useSearchParams } from "next/navigation";

export default function useUtm() {
  const searchParams = useSearchParams();

  const utmParams = getUriQuery(searchParams.toString(), UtmList);

  return { utmParams };
}
